import React from "react";

function Hippo() {
  return (
    <>
      <iframe src="https://my.spline.design/hippo-07207b9af4bea402042e997e167d59a6/" allow="full"></iframe>
    </>
  );
}

export default Hippo;
